import { useState, type FormEvent } from 'react';
import { apiFetch } from '../lib/api.js';
import { C } from '../lib/theme.js';
import { Button, ErrorLine } from '../ui/ui.js';
import type { OrgSummary } from '../lib/types.js';

const labelStyle = {
  display: 'grid',
  gap: 6,
  font: `500 10px 'IBM Plex Mono',monospace`,
  color: C.muted,
  letterSpacing: '.1em',
} as const;

export function CreateOrgForm({ onCreated }: { onCreated: (org: OrgSummary) => void }) {
  const [name, setName] = useState('');
  const [currency, setCurrency] = useState('THB');
  const [timezone, setTimezone] = useState('Asia/Bangkok');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const org = await apiFetch<OrgSummary>('/api/orgs', {
        method: 'POST',
        body: JSON.stringify({ name, default_currency: currency, timezone }),
      });
      setName('');
      onCreated(org);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to create organization');
    } finally {
      setBusy(false);
    }
  }

  return (
    <form onSubmit={submit} style={{ display: 'grid', gap: 10, maxWidth: 380 }}>
      <label style={labelStyle}>
        ORGANIZATION NAME
        <input
          className="field"
          required
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Phuket Cleanse"
        />
      </label>
      <div style={{ display: 'flex', gap: 10 }}>
        <label style={{ ...labelStyle, flex: 1 }}>
          CURRENCY
          <input className="field" value={currency} onChange={(e) => setCurrency(e.target.value)} />
        </label>
        <label style={{ ...labelStyle, flex: 2 }}>
          TIMEZONE
          <input className="field" value={timezone} onChange={(e) => setTimezone(e.target.value)} />
        </label>
      </div>
      <Button variant="primary" type="submit" disabled={busy} style={{ justifySelf: 'start' }}>
        {busy ? 'Creating…' : 'Create organization'}
      </Button>
      {error && <ErrorLine>{error}</ErrorLine>}
    </form>
  );
}
